/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { CodePostalDto } from '../models/code-postal-dto';
import { DataSourceLoadOptionsBase } from '../models/data-source-load-options-base';
import { LoadResult } from '../models/load-result';


/**
 * Fonctions de gestion des codes postaux
 */
@Injectable({
  providedIn: 'root',
})
export class CodesPostauxService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation codePostalGetList
   */
  static readonly CodePostalGetListPath = '/api/codes-postaux/list';

  /**
   * Renvoie la liste des codes postaux.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `codePostalGetList()` instead.
   *
   * This method doesn't expect any request body.
   */
  codePostalGetList$Response(params?: {
  }): Observable<StrictHttpResponse<Array<CodePostalDto>>> {

    const rb = new RequestBuilder(this.rootUrl, CodesPostauxService.CodePostalGetListPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<CodePostalDto>>;
      })
    );
  }

  /**
   * Renvoie la liste des codes postaux.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `codePostalGetList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  codePostalGetList(params?: {
  }): Observable<Array<CodePostalDto>> {

    return this.codePostalGetList$Response(params).pipe(
      map((r: StrictHttpResponse<Array<CodePostalDto>>) => r.body as Array<CodePostalDto>)
    );
  }

  /**
   * Path part for operation codePostalGetListAcceptes
   */
  static readonly CodePostalGetListAcceptesPath = '/api/codes-postaux/list-accepted';

  /**
   * Renvoie la liste des codes postaux actifs et acceptés.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `codePostalGetListAcceptes()` instead.
   *
   * This method doesn't expect any request body.
   */
  codePostalGetListAcceptes$Response(params?: {
  }): Observable<StrictHttpResponse<Array<CodePostalDto>>> {

    const rb = new RequestBuilder(this.rootUrl, CodesPostauxService.CodePostalGetListAcceptesPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<CodePostalDto>>;
      })
    );
  }

  /**
   * Renvoie la liste des codes postaux actifs et acceptés.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `codePostalGetListAcceptes$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  codePostalGetListAcceptes(params?: {
  }): Observable<Array<CodePostalDto>> {

    return this.codePostalGetListAcceptes$Response(params).pipe(
      map((r: StrictHttpResponse<Array<CodePostalDto>>) => r.body as Array<CodePostalDto>)
    );
  }

  /**
   * Path part for operation codePostalLoadList
   */
  static readonly CodePostalLoadListPath = '/api/codes-postaux/load-list';

  /**
   * Renvoie la liste des codes postaux (avec support pour groupement, filtrage, pagination et tri).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `codePostalLoadList()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  codePostalLoadList$Response(params: {

    /**
     * Identifiant du parc
     */
    parcId?: number;

    /**
     * Paramètres de groupement, filtrage, pagination et tri
     */
    body: DataSourceLoadOptionsBase
  }): Observable<StrictHttpResponse<LoadResult>> {

    const rb = new RequestBuilder(this.rootUrl, CodesPostauxService.CodePostalLoadListPath, 'post');
    if (params) {
      rb.query('parcId', params.parcId, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<LoadResult>;
      })
    );
  }

  /**
   * Renvoie la liste des codes postaux (avec support pour groupement, filtrage, pagination et tri).
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `codePostalLoadList$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  codePostalLoadList(params: {

    /**
     * Identifiant du parc
     */
    parcId?: number;

    /**
     * Paramètres de groupement, filtrage, pagination et tri
     */
    body: DataSourceLoadOptionsBase
  }): Observable<LoadResult> {

    return this.codePostalLoadList$Response(params).pipe(
      map((r: StrictHttpResponse<LoadResult>) => r.body as LoadResult)
    );
  }

  /**
   * Path part for operation codePostalGet
   */
  static readonly CodePostalGetPath = '/api/codes-postaux/{id}';

  /**
   * Renvoie le code postal spécifié.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `codePostalGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  codePostalGet$Response(params: {

    /**
     * Identifiant du code postal
     */
    id: number;
  }): Observable<StrictHttpResponse<CodePostalDto>> {

    const rb = new RequestBuilder(this.rootUrl, CodesPostauxService.CodePostalGetPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<CodePostalDto>;
      })
    );
  }

  /**
   * Renvoie le code postal spécifié.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `codePostalGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  codePostalGet(params: {

    /**
     * Identifiant du code postal
     */
    id: number;
  }): Observable<CodePostalDto> {

    return this.codePostalGet$Response(params).pipe(
      map((r: StrictHttpResponse<CodePostalDto>) => r.body as CodePostalDto)
    );
  }

  /**
   * Path part for operation codePostalPut
   */
  static readonly CodePostalPutPath = '/api/codes-postaux/{id}';

  /**
   * Met à jour le code postal spécifié.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `codePostalPut()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  codePostalPut$Response(params: {

    /**
     * Identifiant du code postal à mettre à jour
     */
    id: number;

    /**
     * Code postal
     */
    body: CodePostalDto
  }): Observable<StrictHttpResponse<CodePostalDto>> {

    const rb = new RequestBuilder(this.rootUrl, CodesPostauxService.CodePostalPutPath, 'put');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<CodePostalDto>;
      })
    );
  }

  /**
   * Met à jour le code postal spécifié.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `codePostalPut$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  codePostalPut(params: {

    /**
     * Identifiant du code postal à mettre à jour
     */
    id: number;

    /**
     * Code postal
     */
    body: CodePostalDto
  }): Observable<CodePostalDto> {

    return this.codePostalPut$Response(params).pipe(
      map((r: StrictHttpResponse<CodePostalDto>) => r.body as CodePostalDto)
    );
  }

  /**
   * Path part for operation codePostalDelete
   */
  static readonly CodePostalDeletePath = '/api/codes-postaux/{id}';

  /**
   * Supprime le code postal spécifié.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `codePostalDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  codePostalDelete$Response(params: {

    /**
     * Identifiant du code postal à supprimer
     */
    id: number;
  }): Observable<StrictHttpResponse<number>> {

    const rb = new RequestBuilder(this.rootUrl, CodesPostauxService.CodePostalDeletePath, 'delete');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: parseFloat(String((r as HttpResponse<any>).body)) }) as StrictHttpResponse<number>;
      })
    );
  }

  /**
   * Supprime le code postal spécifié.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `codePostalDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  codePostalDelete(params: {

    /**
     * Identifiant du code postal à supprimer
     */
    id: number;
  }): Observable<number> {

    return this.codePostalDelete$Response(params).pipe(
      map((r: StrictHttpResponse<number>) => r.body as number)
    );
  }

  /**
   * Path part for operation codePostalPost
   */
  static readonly CodePostalPostPath = '/api/codes-postaux';

  /**
   * Crée le code postal spécifié.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `codePostalPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  codePostalPost$Response(params: {

    /**
     * Code postal
     */
    body: CodePostalDto
  }): Observable<StrictHttpResponse<CodePostalDto>> {

    const rb = new RequestBuilder(this.rootUrl, CodesPostauxService.CodePostalPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<CodePostalDto>;
      })
    );
  }

  /**
   * Crée le code postal spécifié.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `codePostalPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  codePostalPost(params: {

    /**
     * Code postal
     */
    body: CodePostalDto
  }): Observable<CodePostalDto> {

    return this.codePostalPost$Response(params).pipe(
      map((r: StrictHttpResponse<CodePostalDto>) => r.body as CodePostalDto)
    );
  }

  /**
   * Path part for operation codePostalDesactivate
   */
  static readonly CodePostalDesactivatePath = '/api/codes-postaux/{id}/desactivate';

  /**
   * Désactive le code postal spécifié.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `codePostalDesactivate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  codePostalDesactivate$Response(params: {

    /**
     * Identifiant du code postal à désactiver
     */
    id: number;

    /**
     * Paramètres de désactivation
     */
    body: CodePostalDto
  }): Observable<StrictHttpResponse<number>> {

    const rb = new RequestBuilder(this.rootUrl, CodesPostauxService.CodePostalDesactivatePath, 'put');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: parseFloat(String((r as HttpResponse<any>).body)) }) as StrictHttpResponse<number>;
      })
    );
  }

  /**
   * Désactive le code postal spécifié.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `codePostalDesactivate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  codePostalDesactivate(params: {

    /**
     * Identifiant du code postal à désactiver
     */
    id: number;

    /**
     * Paramètres de désactivation
     */
    body: CodePostalDto
  }): Observable<number> {

    return this.codePostalDesactivate$Response(params).pipe(
      map((r: StrictHttpResponse<number>) => r.body as number)
    );
  }

  /**
   * Path part for operation codePostalGetByReference
   */
  static readonly CodePostalGetByReferencePath = '/api/codes-postaux/reference/{reference}';

  /**
   * Renvoie le code postal recherché par référence.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `codePostalGetByReference()` instead.
   *
   * This method doesn't expect any request body.
   */
  codePostalGetByReference$Response(params: {

    /**
     * Référence
     */
    reference: string;
  }): Observable<StrictHttpResponse<CodePostalDto>> {

    const rb = new RequestBuilder(this.rootUrl, CodesPostauxService.CodePostalGetByReferencePath, 'get');
    if (params) {
      rb.path('reference', params.reference, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<CodePostalDto>;
      })
    );
  }

  /**
   * Renvoie le code postal recherché par référence.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `codePostalGetByReference$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  codePostalGetByReference(params: {

    /**
     * Référence
     */
    reference: string;
  }): Observable<CodePostalDto> {

    return this.codePostalGetByReference$Response(params).pipe(
      map((r: StrictHttpResponse<CodePostalDto>) => r.body as CodePostalDto)
    );
  }

}
